import React from "react";
import { CheckCircle2, AlertTriangle, ShieldAlert } from "lucide-react";

const CONFIG = {
  verde: {
    testid: "traffic-light-green",
    label: "CONFORME",
    sub: "Discostamento < 2%",
    color: "#00E676",
    bg: "bg-emerald-500/10",
    border: "border-emerald-500/40",
    text: "text-emerald-400",
    icon: CheckCircle2,
  },
  giallo: {
    testid: "traffic-light-yellow",
    label: "TOLLERANZA",
    sub: "Discostamento ≤ 10% · Art. 34-bis",
    color: "#FFC400",
    bg: "bg-amber-500/10",
    border: "border-amber-500/40",
    text: "text-amber-400",
    icon: AlertTriangle,
  },
  rosso: {
    testid: "traffic-light-red",
    label: "DIFFORMITÀ",
    sub: "Discostamento > 10%",
    color: "#FF1744",
    bg: "bg-rose-500/10",
    border: "border-rose-500/40",
    text: "text-rose-400",
    icon: ShieldAlert,
  },
};

export const TrafficLight = ({ status, percentage }) => {
  const cfg = CONFIG[status] || CONFIG.giallo;
  const Icon = cfg.icon;
  return (
    <div data-testid={cfg.testid} className={`rounded-xl border ${cfg.border} ${cfg.bg} p-5`}>
      <div className="flex items-center gap-4">
        <div className="relative">
          <div className="flex flex-col gap-1.5 p-2 rounded-lg bg-black/30 border border-white/5">
            {["verde", "giallo", "rosso"].map((s) => (
              <span
                key={s}
                className="h-3 w-3 rounded-full transition-all"
                style={{
                  backgroundColor: s === status ? CONFIG[s].color : "#1e293b",
                  boxShadow: s === status ? `0 0 12px ${CONFIG[s].color}` : "none",
                }}
              />
            ))}
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <Icon className={`h-5 w-5 ${cfg.text}`} />
            <span className={`font-mono-t text-sm tracking-widest font-semibold ${cfg.text}`}>{cfg.label}</span>
          </div>
          <p className="text-xs text-slate-400 mt-1">{cfg.sub}</p>
        </div>
        {percentage != null && (
          <div className="text-right">
            <p data-testid="discrepancy-percentage-value" className={`font-heading text-3xl font-bold ${cfg.text}`}>
              {percentage}%
            </p>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">discostamento</p>
          </div>
        )}
      </div>
    </div>
  );
};
